(function () {
  document.querySelectorAll('[data-abb]').forEach(function (root) {
    const selected = new Map();

    const itemsWrap = root.querySelector('[data-summary-items]');
    const subtotalEl = root.querySelector('[data-subtotal]');
    const savingEl = root.querySelector('[data-saving]');
    const totalEl = root.querySelector('[data-total]');
    const addBundleBtn = root.querySelector('[data-add-bundle]');
    const statusEl = root.querySelector('[data-status]');

    const codeInput = root.querySelector('[data-discount-code-input]');
    const codeApplyBtn = root.querySelector('[data-apply-discount-code]');
    const codeMessage = root.querySelector('[data-discount-code-message]');
    const codeSavingRow = root.querySelector('[data-code-saving-row]');
    const codeSavingEl = root.querySelector('[data-code-saving]');

    const welcomeCode = 'diy10';
    const welcomeDiscountPercent = 10;

    const viseDiscountPercent = 2;

    const accessoryDiscountTiers = {
      1: 3,
      2: 5,
      3: 7
    };

    let welcomeCodeApplied = false;
    let appliedWelcomeCode = '';

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function isViseItem(item) {
      const title = String(item.title || '').toLowerCase();

      return title.includes('vise') || title.includes('vice');
    }

    function getQualifyingProductCount() {
      let qualifyingCount = 0;

      selected.forEach(function (item) {
        if (item.unlocksDiscount === true && item.qty > 0) {
          qualifyingCount++;
        }
      });

      return qualifyingCount;
    }

    function getAccessoryDiscountPercent(qualifyingCount) {
      if (qualifyingCount >= 3) {
        return accessoryDiscountTiers[3];
      }

      if (qualifyingCount === 2) {
        return accessoryDiscountTiers[2];
      }

      if (qualifyingCount === 1) {
        return accessoryDiscountTiers[1];
      }

      return 0;
    }

    function calculateTotals() {
      let subtotal = 0;
      let viseSubtotal = 0;
      let accessorySubtotal = 0;

      selected.forEach(function (item) {
        const lineTotal = item.price * item.qty;

        subtotal += lineTotal;

        if (isViseItem(item)) {
          viseSubtotal += lineTotal;
        } else {
          accessorySubtotal += lineTotal;
        }
      });

      const qualifyingCount = getQualifyingProductCount();
      const discountUnlocked = qualifyingCount >= 1;

      const accessoryDiscountPercent =
        getAccessoryDiscountPercent(qualifyingCount);

      const viseSaving = discountUnlocked
        ? Math.round(
            viseSubtotal *
              viseDiscountPercent /
              100
          )
        : 0;

      const accessorySaving = discountUnlocked
        ? Math.round(
            accessorySubtotal *
              accessoryDiscountPercent /
              100
          )
        : 0;

      const bundleSaving =
        viseSaving + accessorySaving;

      const afterBundleTotal =
        subtotal - bundleSaving;

      const welcomeSaving =
        welcomeCodeApplied
          ? Math.round(
              afterBundleTotal *
                welcomeDiscountPercent /
                100
            )
          : 0;

      const total =
        afterBundleTotal - welcomeSaving;

      return {
        subtotal,
        viseSubtotal,
        accessorySubtotal,
        qualifyingCount,
        discountUnlocked,
        accessoryDiscountPercent,
        viseSaving,
        accessorySaving,
        bundleSaving,
        welcomeSaving,
        total
      };
    }

    function updateCards() {
      root
        .querySelectorAll('[data-product-card]')
        .forEach(function (card) {
          const id = card.dataset.variantId;
          const item = selected.get(id);

          const addButton =
            card.querySelector('[data-add-item]');

          const qtyWrap =
            card.querySelector('[data-card-qty-wrap]');

          const qtyText =
            card.querySelector('[data-card-qty]');

          if (item) {
            card.classList.add('is-selected');

            if (addButton) {
              addButton.textContent = 'Added';
            }

            if (qtyWrap) {
              qtyWrap.style.display = 'flex';
            }

            if (qtyText) {
              qtyText.textContent = item.qty;
            }
          } else {
            card.classList.remove('is-selected');

            if (addButton) {
              addButton.textContent =
                addButton.dataset.defaultText ||
                'Add to bundle';
            }

            if (qtyWrap) {
              qtyWrap.style.display = 'none';
            }

            if (qtyText) {
              qtyText.textContent = '1';
            }
          }
        });
    }

    function render() {
      const totals = calculateTotals();

      if (subtotalEl) {
        subtotalEl.textContent =
          money(totals.subtotal);
      }

      if (savingEl) {
        savingEl.textContent =
          totals.bundleSaving > 0
            ? '-' + money(totals.bundleSaving)
            : '$0.00';
      }

      if (totalEl) {
        totalEl.textContent =
          money(totals.total);
      }

      if (codeSavingRow && codeSavingEl) {
        if (
          welcomeCodeApplied &&
          totals.welcomeSaving > 0
        ) {
          codeSavingRow.style.display = '';
          codeSavingEl.textContent =
            '-' + money(totals.welcomeSaving);
        } else {
          codeSavingRow.style.display = 'none';
          codeSavingEl.textContent = '$0.00';
        }
      }

      if (itemsWrap) {
        itemsWrap.innerHTML = '';
      }

      if (selected.size === 0) {
        if (itemsWrap) {
          itemsWrap.innerHTML =
            '<p class="abb-summary__empty">' +
            'Your selected items will appear here.' +
            '</p>';
        }

        if (addBundleBtn) {
          addBundleBtn.disabled = true;
        }

        if (statusEl) {
          statusEl.textContent = '';
        }

        updateCards();
        return;
      }

      selected.forEach(function (item) {
        if (!itemsWrap) {
          return;
        }

        itemsWrap.innerHTML += `
          <div class="abb-summary-item">
            <div class="abb-summary-item__top">
              <span>${item.title}</span>
              <span>${money(item.price * item.qty)}</span>
            </div>

            <div class="abb-summary-item__controls">
              <button
                type="button"
                data-minus="${item.id}"
                aria-label="Decrease quantity"
              >
                −
              </button>

              <strong>${item.qty}</strong>

              <button
                type="button"
                data-plus="${item.id}"
                aria-label="Increase quantity"
              >
                +
              </button>

              <button
                type="button"
                class="abb-summary-item__remove"
                data-remove="${item.id}"
              >
                Remove
              </button>
            </div>
          </div>
        `;
      });

      if (addBundleBtn) {
        addBundleBtn.disabled = false;
      }

      if (statusEl) {
        if (!totals.discountUnlocked) {
          statusEl.textContent =
            'Add at least 1 eligible Jaw or the IQ Connect ' +
            'Hands-Free Accessory System to unlock your bundle saving.';
        } else {
          statusEl.textContent = '';
        }
      }

      updateCards();
    }

    function addItemFromCard(card) {
      if (!card) {
        return;
      }

      const id = card.dataset.variantId;
      const title = card.dataset.productTitle;
      const price =
        Number(card.dataset.price || 0);

      const unlocksDiscount =
        card.dataset.unlocksDiscount === 'true';

      if (!id || !price) {
        return;
      }

      if (selected.has(id)) {
        selected.get(id).qty++;
      } else {
        selected.set(id, {
          id,
          title,
          price,
          qty: 1,
          unlocksDiscount
        });
      }

      render();
    }

    async function applyDiscountToCart(code) {
      const response = await fetch(
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart/update.js'
          : '/cart/update.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            discount: code
          })
        }
      );

      if (!response.ok) {
        throw new Error('Discount could not be applied.');
      }

      return await response.json();
    }

    if (codeApplyBtn && codeInput) {
      codeApplyBtn.addEventListener(
        'click',
        function () {
          const enteredCode =
            codeInput.value
              .trim()
              .toLowerCase();

          if (!enteredCode) {
            welcomeCodeApplied = false;
            appliedWelcomeCode = '';

            if (codeMessage) {
              codeMessage.textContent =
                'Enter your welcome code to preview your extra 10% saving.';
            }

            render();
            return;
          }

          if (enteredCode === welcomeCode) {
            welcomeCodeApplied = true;
            appliedWelcomeCode =
              codeInput.value.trim();

            if (codeMessage) {
              codeMessage.textContent =
                '✓ Welcome discount recognised. It will be applied automatically when you add your bundle to cart.';
            }
          } else {
            welcomeCodeApplied = false;
            appliedWelcomeCode = '';

            if (codeMessage) {
              codeMessage.textContent =
                'That code was not recognised. Please check and try again.';
            }
          }

          render();
        }
      );

      codeInput.addEventListener(
        'keydown',
        function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            codeApplyBtn.click();
          }
        }
      );
    }

    root.addEventListener(
      'click',
      function (event) {
        const add =
          event.target.closest('[data-add-item]');

        const cardPlus =
          event.target.closest('[data-card-plus]');

        const cardMinus =
          event.target.closest('[data-card-minus]');

        const plus =
          event.target.closest('[data-plus]');

        const minus =
          event.target.closest('[data-minus]');

        const remove =
          event.target.closest('[data-remove]');

        if (add) {
          addItemFromCard(
            add.closest('[data-product-card]')
          );

          return;
        }

        if (cardPlus) {
          const card =
            cardPlus.closest(
              '[data-product-card]'
            );

          if (!card) {
            return;
          }

          const id = card.dataset.variantId;

          if (selected.has(id)) {
            selected.get(id).qty++;
          }

          render();
          return;
        }

        if (cardMinus) {
          const card =
            cardMinus.closest(
              '[data-product-card]'
            );

          if (!card) {
            return;
          }

          const id = card.dataset.variantId;
          const item = selected.get(id);

          if (!item) {
            return;
          }

          item.qty--;

          if (item.qty <= 0) {
            selected.delete(id);
          }

          render();
          return;
        }

        if (plus) {
          const item =
            selected.get(plus.dataset.plus);

          if (!item) {
            return;
          }

          item.qty++;
          render();
          return;
        }

        if (minus) {
          const item =
            selected.get(minus.dataset.minus);

          if (!item) {
            return;
          }

          item.qty--;

          if (item.qty <= 0) {
            selected.delete(
              minus.dataset.minus
            );
          }

          render();
          return;
        }

        if (remove) {
          selected.delete(
            remove.dataset.remove
          );

          render();
        }
      }
    );

    if (addBundleBtn) {
      addBundleBtn.addEventListener(
        'click',
        async function () {
          if (selected.size === 0) {
            return;
          }

          addBundleBtn.disabled = true;

          if (statusEl) {
            statusEl.textContent =
              'Adding bundle to cart...';
          }

          const items =
            Array.from(
              selected.values()
            ).map(
              function (item) {
                return {
                  id: Number(item.id),
                  quantity: item.qty
                };
              }
            );

          try {
            const addResponse =
              await fetch(
                window.Shopify &&
                window.Shopify.routes &&
                window.Shopify.routes.root
                  ? window.Shopify.routes.root + 'cart/add.js'
                  : '/cart/add.js',
                {
                  method: 'POST',
                  headers: {
                    'Content-Type':
                      'application/json',
                    'Accept':
                      'application/json'
                  },
                  body:
                    JSON.stringify({
                      items
                    })
                }
              );

            if (!addResponse.ok) {
              throw new Error(
                'Cart request failed.'
              );
            }

            if (
              welcomeCodeApplied &&
              appliedWelcomeCode
            ) {
              if (statusEl) {
                statusEl.textContent =
                  'Applying your welcome discount...';
              }

              await applyDiscountToCart(
                appliedWelcomeCode
              );
            }

            window.location.href = '/cart';

          } catch (error) {
            console.error(
              'Amarra Bundle Builder cart error:',
              error
            );

            if (statusEl) {
              statusEl.textContent =
                'Sorry, something went wrong. Please try again.';
            }

            addBundleBtn.disabled = false;
          }
        }
      );
    }

    render();
  });
})();